import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';

export function Slider({ images }) {
  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      navigation
      autoplay={{
        delay: 3000, // 3 seconds
        disableOnInteraction: false, // keeps autoplay even after user interaction
      }}
      spaceBetween={10}
      slidesPerView={1}
      className="rounded-xl overflow-hidden"
    >
      {images.map((img, idx) => (
        <SwiperSlide key={idx}>
          <img
            style={{ width: '100%' }}
            src={img}
            alt={`Slide ${idx + 1}`}
            className="w-full h-60 object-cover"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
